import Layouts from "./layouts/index.js";
const { // plop_marker:segment_index_import_layout
DynamicDevlink } = Layouts;
export default {
    // plop_marker:segment_index_add_layout
    DynamicDevlinkComponent: {
        type: "DynamicDevlinkComponent",
        title: "Dynamic",
        imgSrc: "/static/img/segments/layouts/dynamic-devlink.png",
        config: DynamicDevlink.DynamicDevlinkConfig,
        advancedConfig: DynamicDevlink.DynamicDevlinkAdvancedConfig,
        component: DynamicDevlink.DynamicDevlinkComponent
    }
};
